"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (range, dateTimeModifier, dateTimeProvider, cb) => {
    let date = dateTimeProvider.fromDateTimeToDate(range.from);
    const dayAfter = dateTimeProvider.fromDateTimeToDate(dateTimeModifier.modifyDays(range.to, 1));
    while (dayAfter !== date) {
        cb(date);
        date = dateTimeProvider.fromDateTimeToDate(dateTimeModifier.modifyDays(date, 1));
    }
};
//# sourceMappingURL=iterateDateRange.js.map